export default "__VITE_ASSET__BRyAiVl5__"